export const AI_AGENTS_CLIENT_IDS = [710417, 9, 2, 14952];
export const AI_CASES_PLAYBOOKS_CLIENT_IDS = [710417, 9];
export const V1_V2_TABLE_CHOICE_CLIENT_IDS = [2];


/**
 * Inline canvas editing is now always ON for all workflows.
 * The legacy pane/drawer UI is no longer used.
 */
export function isInlineCanvasEditingEnabled() {
  return true;
}

/**
 * Cohort allowlist for progressive rollout.
 * Empty array = enabled for all. Populated = only these client IDs.
 * Set to [] for full rollout.
 */
const CANONICAL_PLACEHOLDER_MAP_COHORT = [];
const SESSION_IO_V1_RENDERING_COHORT = [];

export function isCanonicalPlaceholderMapEnabled(clientId) {
  if (typeof window === 'undefined') return true;
  try {
    if (window.localStorage.getItem('wf86.disablePlaceholderMapV2') === '1') return false;
  } catch (_) {}

  if (CANONICAL_PLACEHOLDER_MAP_COHORT.length > 0 && clientId != null) {
    return CANONICAL_PLACEHOLDER_MAP_COHORT.includes(Number(clientId));
  }
  return true;
}

export function isSessionIoV1RenderingEnabled(clientId) {
  if (typeof window === 'undefined') return true;
  try {
    if (window.localStorage.getItem('wf86.disableSessionIoV1Rendering') === '1') return false;
  } catch (_) {}

  if (SESSION_IO_V1_RENDERING_COHORT.length > 0 && clientId != null) {
    return SESSION_IO_V1_RENDERING_COHORT.includes(Number(clientId));
  }
  return true;
}

export function isTypedChatChunksEnabled() { return true; }
export function isTypedChatRendererEnabled() { return true; }
export function isTypedChatTransportEnabled() { return true; }
